import { Button } from '@mui/material';
import React, { useRef, useState } from 'react';
import AsyncSelect from 'react-select/async';
import { getCashInvoiceList, getInsuranceInvoiceList, validERP } from './ApiMethods';

const InvoiceFilters = ({ filters, setFilters, setInvoiceList, setLoading, type }) => {
  const [selectedOption, setSelectedOptions] = useState(null);
  const emptyOptionsMessage = useRef('search');

  const loadOptions = async inputValue => {
    const payload = { query: inputValue };
    const response = await validERP.post('searchCustomer', payload);
    if (!response?.data?.data?.length) {
      emptyOptionsMessage.current = 'No options found';
      return [];
    }
    return response?.data?.data?.map(({ name, id }) => ({ label: name, value: id }));
  };

  const handleChange = optionValue => {
    setSelectedOptions(optionValue);
    setFilters(prevValues => ({
      ...prevValues,
      customer_id: optionValue?.value,
      customer_name: optionValue?.label
    }));
  };

  const getAsyncValue = () => {
    return selectedOption && { label: selectedOption?.label, value: selectedOption?.value };
  };

  const handleAddFilters = () => {
    if (type === 'insurance') {
      getInsuranceInvoiceList(setLoading, setInvoiceList, filters);
    } else {
      getCashInvoiceList(setLoading, setInvoiceList, filters);
    }
  };
  const hanldeResetFilters = () => {
    if (type === 'insurance') {
      let payload = {
        branch_id: '',
        company_id: '',
        customer_id: 0,
        customer_name: '',
        end_date: '',
        page: 1,
        payment_method: '',
        per_page: 10,
        start_date: ''
      };
      setFilters(payload);
      getInsuranceInvoiceList(setLoading, setInvoiceList, payload);
    } else {
      let payload = {
        branch_id: '',
        customer_id: 0,
        customer_name: '',
        end_date: '',
        invoice_type: 'sales',
        page: 1,
        payment_method: '',
        per_page: 10,
        start_date: ''
      };
      getCashInvoiceList(setLoading, setInvoiceList, payload);
      setFilters(payload);
    }
    setSelectedOptions(null);
  };

  return (
    <div>
      <div className='flex items-center justify-end mb-2 gap-2'>
        <div>
          <label className='text-base font-medium'>Start Date</label>
          <input
            id='start'
            type='date'
            className='w-full border rounded-md !p-1.5'
            value={filters?.start_date}
            onChange={e => {
              setFilters(prevValues => ({
                ...prevValues,
                start_date: e.target.value
              }));
            }}
          />
        </div>
        <div>
          <label className='text-base font-medium'>End Date</label>
          <input
            id='end'
            type='date'
            className='w-full border rounded-md !p-1.5'
            value={filters?.end_date}
            onChange={e => {
              setFilters(prevValues => ({
                ...prevValues,
                end_date: e.target.value
              }));
            }}
          />
        </div>
        <div>
          <label className='text-base font-medium'>Search Patient</label>
          <AsyncSelect
            classNames={{
              control: state => (state.isFocused ? '!border-primary' : '!border-gray-300')
            }}
            classNamePrefix='select'
            className={`!cursor-text !p-0 !w-[250px] border-gray-300 rounded-md hover:!border-primary !outline-none shadow-none `}
            loadOptions={loadOptions}
            value={getAsyncValue()}
            onChange={handleChange}
            placeholder='Search Patient'
            noOptionsMessage={() => emptyOptionsMessage.current}
            isClearable={true}
          />
        </div>
        <Button
          onClick={handleAddFilters}
          variant='contained'
          type='button'
          size='small'
          className='w-fit !mt-[20px] flex justify-center rounded-md bg-gradient-to-r from-[#f14f3e] to-[#fab768] px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-md focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 normal-case'
        >
          Apply Filters
        </Button>
        <Button
          onClick={hanldeResetFilters}
          variant='contained'
          type='button'
          size='small'
          className='flex w-fit !mt-[20px] justify-center rounded-md bg-gradient-to-r !bg-gray-800 px-3 py-1.5 text-sm font-semibold leading-6 text-black shadow-md focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 normal-case'
        >
          Reset
        </Button>
      </div>
    </div>
  );
};

export default InvoiceFilters;
